module.exports = __webpack_public_path__ + "static/media/google.cbf96f11.png";